// import React, { useContext, useEffect, useState } from "react";
// import { toast } from "react-hot-toast";
// import { useLanguage } from "../../../Providers/LanguageContext";
// import { SpeechContext } from "../../../Providers/SpeechWrapper";
// import { UserContext } from "../../../Providers/UserWrapper";
// import HttpClient from "../../../utils/HttpClient";
// import DashboardFivePieChart from "./DashboardFivePieChart";
// function DashboardChartFive({ selectedYearFromDashboardPage, time }) {
//   const { language } = useLanguage();
//   const { profileData } = useContext(UserContext);
//   const { setShowGif, setGifToShow } = useContext(SpeechContext);
//   const [dashboardFiveData, setDashBoardFiveData] = useState({
//     currentAr: 0,
//     pastDueAr: 0,
//   });
//   const [filters, setFilters] = useState({
//     customerName: "",
//     startDate: "",
//     endDate: "",
//   });
//   useEffect(() => {
//     if (profileData && profileData?.userType === "Business") {
//       // if(!filters.customerName && filters.startDate && filters.endDate){
//       //     fetchDashboardFiveBu(filters)
//       // }else if(filters.customerName && filters.startDate && filters.endDate ){
//       //     fetchDashboardFiveBu(filters)
//       // }else if(filters.customerName && !filters.startDate && !filters.endDate){
//       //     fetchDashboardFiveBu(filters)
//       // }
//       if (
//         (filters.startDate !== "" && filters.endDate !== "") ||
//         filters.startDate === "" ||
//         filters.endDate === ""
//       ) {
//         fetchDashboardFiveBu(filters);
//       }
//     } else if (profileData && profileData?.userType !== "Business") {
//       fetchDashboardFivePu(filters);
//     }
//   }, [filters, profileData]);

//   async function fetchDashboardFiveBu(filt) {
//     const res = await HttpClient.requestData("dashboard-five-bu", "POST", filt);
//     if (res && res.status) {
//       if (res.message && res.message.trim() === "Dashboard rewards 1 points") {
//         setShowGif(true);
//         setGifToShow("Dashboard rewards 1 points");
//       }
//       setDashBoardFiveData(res.data);
//     }
//   }

//   async function fetchDashboardFivePu(filt) {
//     const res = await HttpClient.requestData("dashboard-five-pu", "POST", filt);
//     if (res && res.status) {
//       if (res.message && res.message.trim() === "Dashboard rewards 1 points") {
//         setShowGif(true);
//         setGifToShow("Dashboard rewards 1 points");
//       }
//       setDashBoardFiveData(res.data);
//     }
//   }

//   useEffect(() => {
//     console.log(dashboardFiveData, "dashboardFiveData");
//   }, [dashboardFiveData]);
//   return (
//     <div id="config-form">
//       <div className="container">
//         <div className="">
//           <div className="d-flex justify-content-end">
//             <button
//               style={{ background: "transparent", border: "none" }}
//               onClick={() => {
//                 setFilters({
//                   customerName: "",
//                   startDate: "",
//                   endDate: "",
//                 });
//                 toast.success(language.clear_filter);
//               }}
//             >
//               <h5
//                 style={{
//                   color: "#000",
//                 }}
//                 className="my-3"
//               >
//                 {language.clear_filters}
//               </h5>
//             </button>
//           </div>
//           <form>
//             <div className="dashboard-form-layout">
//               <div className="form-group">
//                 <input
//                   style={{
//                     color: "black",
//                   }}
//                   type="text"
//                   className="form-control"
//                   id=""
//                   aria-describedby=""
//                   placeholder={language.customer_name}
//                   value={filters.customerName}
//                   onChange={(e) =>
//                     setFilters((prev) => ({
//                       ...prev,
//                       customerName: e.target.value,
//                     }))
//                   }
//                 />
//               </div>
//               {time !== "year" && (
//                 <div className="form-group">
//                   <div className="row">
//                     <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-sx-12">
//                       <label className="mb-2" style={{ fontSize: "1.2rem" }}>
//                         {language.start_date}
//                       </label>
//                       <input
//                         type="date"
//                         className="form-control mb-3"
//                         id=""
//                         aria-describedby=""
//                         value={filters.startDate}
//                         onChange={(e) =>
//                           setFilters((prev) => ({
//                             ...prev,
//                             startDate: e.target.value,
//                           }))
//                         }
//                       />
//                     </div>
//                     <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-sx-12">
//                       <label className="mb-2" style={{ fontSize: "1.2rem" }}>
//                         {language.final_date}
//                       </label>
//                       <input
//                         type="date"
//                         className="form-control mb-3"
//                         id=""
//                         aria-describedby=""
//                         value={filters.endDate}
//                         onChange={(e) =>
//                           setFilters((prev) => ({
//                             ...prev,
//                             endDate: e.target.value,
//                           }))
//                         }
//                       />
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </form>
//           <h3 className="my-3" style={{ textAlign: "center", color: "#fff" }}>
//             {language.total_open_accounts}
//           </h3>
//           {/* {
//                         Boolean(dashboardFiveData.currentAr) === false && dashboardFiveData.currentAr == 0 && Boolean(dashboardFiveData.pastDueAr) && (
//                             <div className="form-group">
//                                 <input
//                                     style={{
//                                         background: '#0C2537',
//                                         color: '#fff',
//                                         border: 'none',
//                                         padding: '40px 10px',
//                                         fontSize: '20px',
//                                         fontWeight: '500'
//                                     }}
//                                     type="number"
//                                     className="form-control"
//                                     id=""
//                                     aria-describedby=""
//                                     value={dashboardFiveData.currentAr + dashboardFiveData.pastDueAr}
//                                     disabled
//                                 />
//                             </div>
//                         )
//                     }
//                     {
//                         Boolean(dashboardFiveData.pastDueAr) === false && dashboardFiveData.pastDueAr == 0 && Boolean(dashboardFiveData.currentAr) && (
//                             <div className="form-group">
//                                 <input style={{
//                                         background: '#0C2537',
//                                         color: '#fff',
//                                         border: 'none',
//                                         padding: '40px 10px',
//                                         fontSize: '20px',
//                                         fontWeight: '500'
//                                     }}
//                                     type="number"
//                                     className="form-control"
//                                     id=""
//                                     aria-describedby=""
//                                     value={dashboardFiveData.currentAr + dashboardFiveData.pastDueAr}
//                                     disabled
//                                 />
//                             </div>
//                         )
//                     }
//                     {
//                         Boolean(dashboardFiveData.pastDueAr) && Boolean(dashboardFiveData.currentAr) && (
//                             <div className="form-group">
//                                 <input
//                                     type="number"
//                                     className="form-control"
//                                     style={{ borderRadius: "30px",
//                                         color: '#fff',
//                                         border: 'none',
//                                         padding: '40px 10px',
//                                         fontSize: '20px',
//                                         fontWeight: '500'
//                                  }}
//                                     id=""
//                                     aria-describedby=""
//                                     value={dashboardFiveData.currentAr + dashboardFiveData.pastDueAr}
//                                     disabled
//                                 />
//                             </div>
//                         )
//                     }
//                     {
//                         Boolean(dashboardFiveData.pastDueAr) && Boolean(dashboardFiveData.currentAr) && (
//                             <div className='d-flex justify-content-between'>
//                                 <div className='text-center'>
//                                     <span style={{ fontSize: "1.2rem", fontWeight: "500",color:'#fff' }}>{language.currentAr}</span>
//                                     <h3><span class="badge" style={{ background: "black", borderRadius: "15px",color:'#fff' }}>{dashboardFiveData.currentAr}</span></h3>
//                                 </div>
//                                 <div className='text-center'>
//                                     <span style={{ fontSize: "1.2rem", fontWeight: "500",color:'#fff' }}>{language.pastdueAr}</span>
//                                     <h3><span class="badge bg-secondary" style={{ borderRadius: "15px",color:'#fff' }}>{dashboardFiveData.pastDueAr}</span></h3>
//                                 </div>
//                             </div>
//                         )
//                     }
//                     } */}

//           {(Boolean(dashboardFiveData.pastDueAr) ||
//             dashboardFiveData.pastDueAr === 0) &&
//             (Boolean(dashboardFiveData.currentAr) ||
//               dashboardFiveData.currentAr === 0) && (
//               <DashboardFivePieChart
//                 data={[
//                   dashboardFiveData.currentAr,
//                   dashboardFiveData.pastDueAr,
//                 ]}
//               />
//             )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default DashboardChartFive;

import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useLanguage } from "../../../Providers/LanguageContext";
import { SpeechContext } from "../../../Providers/SpeechWrapper";
import { UserContext } from "../../../Providers/UserWrapper";
import HttpClient from "../../../utils/HttpClient";
import DashboardFivePieChart from "./DashboardFivePieChart";

function DashboardChartFive({ selectedYearFromDashboardPage, time }) {
  const { language } = useLanguage();
  const { profileData } = useContext(UserContext);
  const { setShowGif, setGifToShow } = useContext(SpeechContext);
  const [dashboardFiveData, setDashBoardFiveData] = useState({
    currentAr: 0,
    pastDueAr: 0,
  });
  const [filters, setFilters] = useState({
    customerName: "",
    startDate: "",
    endDate: "",
  });

  const [openform, setopenform] = useState(false);

  // Add this useEffect to update filters when year changes
  useEffect(() => {
    if (time === "year" && selectedYearFromDashboardPage) {
      setFilters((prev) => ({
        ...prev,
        startDate: "",
        endDate: "",
        year: selectedYearFromDashboardPage,
      }));
    }
  }, [selectedYearFromDashboardPage, time]);

  useEffect(() => {
    if (profileData && profileData?.userType === "Business") {
      if (
        (filters.startDate !== "" && filters.endDate !== "") ||
        filters.startDate === "" ||
        filters.endDate === ""
      ) {
        fetchDashboardFiveBu(filters);
      }
    } else if (profileData && profileData?.userType !== "Business") {
      fetchDashboardFivePu(filters);
    }
  }, [filters, profileData]);

  async function fetchDashboardFiveBu(filt) {
    // Prepare request body based on time
    const requestBody = prepareRequestBody(filt);

    const res = await HttpClient.requestData(
      "dashboard-five-bu",
      "POST",
      requestBody
    );
    if (res && res.status) {
      if (res.message && res.message.trim() === "Dashboard rewards 1 points") {
        setShowGif(true);
        setGifToShow("Dashboard rewards 1 points");
      }
      setDashBoardFiveData(res.data);
    }
  }

  async function fetchDashboardFivePu(filt) {
    // Prepare request body based on time
    const requestBody = prepareRequestBody(filt);

    const res = await HttpClient.requestData(
      "dashboard-five-pu",
      "POST",
      requestBody
    );
    if (res && res.status) {
      if (res.message && res.message.trim() === "Dashboard rewards 1 points") {
        setShowGif(true);
        setGifToShow("Dashboard rewards 1 points");
      }
      setDashBoardFiveData(res.data);
    }
  }

  // Helper function to prepare request body based on time
  const prepareRequestBody = (filt) => {
    if (time === "year") {
      return {
        customerName: filt.customerName || "",
        year: selectedYearFromDashboardPage || new Date().getFullYear(),
      };
    } else {
      return {
        customerName: filt.customerName || "",
        startDate: filt.startDate || "",
        endDate: filt.endDate || "",
      };
    }
  };

  useEffect(() => {
    console.log(dashboardFiveData, "dashboardFiveData");
  }, [dashboardFiveData]);

  const handleClearFilters = () => {
    if (time === "year") {
      setFilters({
        customerName: "",
        startDate: "",
        endDate: "",
        year: selectedYearFromDashboardPage || new Date().getFullYear(),
      });
    } else {
      setFilters({
        customerName: "",
        startDate: "",
        endDate: "",
      });
    }
    toast.success(language.clear_filter);
  };

  return (
    <div id="config-form">
      <div className="container">
        <div className="">
          <div className="">
            <div className="d-flex justify-content-end">
              {openform ?
                <button
                  style={{ background: "transparent", border: "none" }}
                  onClick={handleClearFilters}
                >
                  <h5
                    style={{
                      color: "white",
                      fontSize: "small"
                    }}
                    className="my-3"
                  >
                    {language.clear_filters}
                  </h5>
                </button>
                :
                <button
                  onClick={() => setopenform(!openform)}
                  style={{ background: "transparent", border: "none" }}
                ><i class="fa-solid fa-arrow-down-short-wide" style={{
                  color: "white",
                  fontSize: "large"
                }}></i></button>
              }
            </div>
            <form>
              {openform &&
                <div className="dashboard-form-layout">
                  <div className="form-group">
                    <input
                      style={{
                        color: "black",
                      }}
                      type="text"
                      className="form-control"
                      id=""
                      aria-describedby=""
                      placeholder={language.customer_name}
                      value={filters.customerName}
                      onChange={(e) =>
                        setFilters((prev) => ({
                          ...prev,
                          customerName: e.target.value,
                        }))
                      }
                    />
                  </div>
                  {time !== "year" && (
                    <div className="form-group">
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-sx-12">
                          <label className="mb-2" style={{ fontSize: "1.2rem" }}>
                            {language.start_date}
                          </label>
                          <input
                            type="date"
                            className="form-control mb-3"
                            id=""
                            aria-describedby=""
                            value={filters.startDate}
                            onChange={(e) =>
                              setFilters((prev) => ({
                                ...prev,
                                startDate: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-sx-12">
                          <label className="mb-2" style={{ fontSize: "1.2rem" }}>
                            {language.final_date}
                          </label>
                          <input
                            type="date"
                            className="form-control mb-3"
                            id=""
                            aria-describedby=""
                            value={filters.endDate}
                            onChange={(e) =>
                              setFilters((prev) => ({
                                ...prev,
                                endDate: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>}
            </form>
          </div>
          <h3 className="my-3" style={{ textAlign: "center", color: "#fff" }}>
            {language.total_open_accounts}
          </h3>

          {(Boolean(dashboardFiveData.pastDueAr) ||
            dashboardFiveData.pastDueAr === 0) &&
            (Boolean(dashboardFiveData.currentAr) ||
              dashboardFiveData.currentAr === 0) && (
              <DashboardFivePieChart
                data={[
                  dashboardFiveData.currentAr,
                  dashboardFiveData.pastDueAr,
                ]}
              />
            )}
        </div>
      </div>
    </div>
  );
}

export default DashboardChartFive;
